import { render, staticRenderFns } from "./customer-send-review-sms.vue?vue&type=template&id=688f64d6&"
import script from "./customer-send-review-sms.vue?vue&type=script&lang=js&"
export * from "./customer-send-review-sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports